import { render, staticRenderFns } from "./stages.vue?vue&type=template&id=5788ca02&scoped=true"
import script from "./stages.vue?vue&type=script&lang=js"
export * from "./stages.vue?vue&type=script&lang=js"
import style0 from "./stages.vue?vue&type=style&index=0&id=5788ca02&prod&scoped=true&lang=css"
import style1 from "./stages.vue?vue&type=style&index=1&id=5788ca02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5788ca02",
  null
  
)

export default component.exports